import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import helpers from "../../common/utils/utils";
import {
  getPartnerNotices,
  getQueryId,
} from "../../state/selectors/general.selectors";
import style from "./partnerNotice.module.scss";

const PartnerNotice = ({ partnerMessages, queryId }) => {
  let tmpl;

  if (partnerMessages && partnerMessages.length !== 0) {
    const allMessagesEmpty = partnerMessages.every((o) => !o.message);

    if (allMessagesEmpty) {
      tmpl = null;
    } else {
      tmpl = (
        <>
          {partnerMessages.map((content, i) => {
            return (
              <div
                key={i}
                className={style.cmsContent}
                style={{
                  backgroundColor: content.background_color || "#f9f9f9",
                }}
              >
                <div
                  // TODO: we can refactor it so it returns jsx instead of HTML
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: helpers.replaceLinkWithLogLink(
                      content.message,
                      queryId
                    ),
                  }}
                />
              </div>
            );
          })}
        </>
      );
    }
  }

  return <div className="varsome-result">{tmpl}</div>;
};

PartnerNotice.propTypes = {
  partnerMessages: PropTypes.arrayOf(PropTypes.shape({})),
  queryId: PropTypes.string,
};

PartnerNotice.defaultProps = {
  partnerMessages: [],
  queryId: "",
};

const mapStateToProps = (state) => ({
  partnerMessages: getPartnerNotices(state),
  queryId: getQueryId(state),
});

export default connect(mapStateToProps)(PartnerNotice);
